module.exports = __webpack_public_path__ + "static/media/hourlyHero2.1f0cd20e.jpg";